import {QueryClientProvider} from '@tanstack/react-query';
import {ReactNode} from 'react';
import {useMatch} from 'react-router';

import {useCampaignTracking} from '@/features/campaign/hooks/useCampaignTracking';
import CookieConsentModal from '@/features/cookieConsentModal';
import queryClient from '@/shared/lib/react-query/queryClient';
import {APP_ROUTES} from '@/utils_legacy/routes';

import {useInternalAnalytics} from './hooks/useInternalAnalytics';
import {useRegisterFirebaseNotificationWorker} from './hooks/useRegisterFirebaseNotificationWorker';
import {useRollbar} from './hooks/useRollbar';
import {useWorker} from './hooks/useWorker';

const App = ({children}: {children: ReactNode}) => {
  const payWallStandalonePage = Boolean(
    useMatch(APP_ROUTES.PayWallBackupPayment)
  );
  const cypressEnv = typeof window !== 'undefined' && Boolean(window.Cypress);
  const skipInitScripts = cypressEnv || payWallStandalonePage;

  useRegisterFirebaseNotificationWorker({skipInit: skipInitScripts});
  useRollbar();
  useWorker({skipInit: skipInitScripts});
  useCampaignTracking();

  // Should use after useCampaignTracking ↑ to send a campaign to analytics
  useInternalAnalytics();

  return (
    <QueryClientProvider client={queryClient}>
      <CookieConsentModal />
      {children}
    </QueryClientProvider>
  );
};

export default App;
